import { notification } from 'antd';
import { useState } from 'react';

import { leasingApi } from '@/components/App/Leasing/api';
import { handleError } from '@/services/handleError';
import { useAppDispatch, useAppSelector } from '@/store';

import { refreshOrderData } from '../../../../store';

const useSubmitOffer = () => {
  const dispatch = useAppDispatch();
  const { request } = useAppSelector((state) => state.ieLeasingOrder);

  const [submitLoadingOfferIds, setSubmitLoadingIds] = useState<string[]>([]);

  const handleSubmitOffer = async (uuid: string) => {
    setSubmitLoadingIds((prev) => [...prev, uuid]);

    try {
      await leasingApi.submitLeasingOfferForReview(uuid);

      const offer = request?.responses.find((item) => item.uuid === uuid);
      notification.success({
        title: `Заявка успешно отправлена в ${
          offer?.leasingCompany.name || 'компанию'
        }`
      });
      dispatch(refreshOrderData());
    } catch (error) {
      handleError(error, {
        customTitle:
          'Не получилось отправить лизинг на рассмотрение. Пожалуйста, попробуйте позже'
      });
    }

    setSubmitLoadingIds((prev) => [...prev].filter((item) => item !== uuid));
  };

  return { handleSubmitOffer, submitLoadingOfferIds };
};

export default useSubmitOffer;
